var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationWomanButtons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M23 72h2v-8h-2zM55 72h2v-8h-2zM54 49h-2V19c0-4.625-3.506-8.445-8-8.944V11c0 .321-.154.623-.415.812a1.002 1.002 0 01-.901.136l-5.842-1.947C31.952 10.086 28 14.09 28 19v30h-2V19c0-6.065 4.935-11 11-11 .107 0 .214.018.316.052L42 9.612V9a1 1 0 011-1c6.065 0 11 4.935 11 11v30",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.618V19a1 1 0 01-1 1c-1.103 0-2 .897-2 2v3c0 6.261 2.504 13 8 13s8-6.739 8-13v-3c0-1.103-.897-2-2-2h-6c-.155 0-.309-.036-.447-.105L35 17.618zM40 40c-6.871 0-10-7.775-10-15v-3a4.005 4.005 0 013-3.873V16a1.001 1.001 0 011.447-.895L40.236 18H46c2.206 0 4 1.794 4 4v3c0 7.225-3.129 15-10 15z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M39 57h2v-2h-2zM39 53h2v-2h-2zM39 61h2v-2h-2zM39 65h2v-2h-2zM39 69h2v-2h-2zM45 61h8v-2h-8z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 72h-2V61c0-6.497 3.23-8.787 9.596-10.919l8.919-4.955.97 1.748-9.169 5.074C17.451 53.903 15 55.594 15 61v11M67 72h-2V61c0-5.406-2.451-7.097-8.316-9.052l-.169-.074-9-5 .97-1.748 8.919 4.955C63.77 52.213 67 54.503 67 61v11M33 44h2v-8h-2zM45 44h2v-8h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.391 44.806l-1.682 4.485 4.485-1.682-2.803-2.803zm10.415 2.803l4.485 1.682-1.682-4.485-2.803 2.803zM50 52a1.03 1.03 0 01-.352-.063L41.818 49h-3.636l-7.83 2.937a1.001 1.001 0 01-1.289-1.289l3-8c.12-.318.393-.553.725-.626.333-.07.679.031.919.271L38.414 47h3.172l4.707-4.707c.24-.24.587-.34.919-.271.332.073.605.308.725.626l3 8A1.003 1.003 0 0150 52z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationWomanButtons;